import { IGetActiveTypesResponse200 } from '../../../common/repositories/infrastructure-caching/v1/get-active-types';
import { IInfrastructureType } from '../../../common/types/infrastructure';

export function prepareInfrastructureTypes(response: IGetActiveTypesResponse200): IInfrastructureType[] {
  const layers: IInfrastructureType[] = [];
  for (const layer of response.response.types) {
    if (layer.drawType === 'pin') {
      const { drawType, ...rest } = layer;
      layers.push(rest);
    }
  }

  return layers;
}
